import { createTheme } from "@mui/material";
// import { indigo } from "@mui/material/colors";

export const theme = createTheme({
  palette: {
    mode: "dark",
    myColor: {
      main: "#2f173a",
      // main: "#2d313a",
      // darker: "#681366",
    },
  },
  customFont: "monospace",
});
